// extracted by mini-css-extract-plugin
module.exports = {"tabs":"_1ltvXiKnd4BSn7X-SRSfG6","headerTitle":"_2qnKkwWMu4T3bBVVUqHYne","headerActions":"_3O5AYmAPoIsqjrx8J_BbM2","headerReserved":"_2EHWNcUy2Lx15aCs-ESgsZ"};